import { render } from "./HomeAccounting.vue?vue&type=template&id=5ac1ffda&scoped=true"
import script from "./HomeAccounting.vue?vue&type=script&lang=js"
export * from "./HomeAccounting.vue?vue&type=script&lang=js"

import "./HomeAccounting.vue?vue&type=style&index=0&id=5ac1ffda&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac1ffda"]])

export default __exports__